
import { places, polishTranslate } from "@book-searcher/data";
import { getKeyByValue } from "../../utils/functions";
import { defineComponent, ref } from "vue";
import Field from "../../components/Field.vue";
import Button from "../../components/buttons/Button.vue";
export default defineComponent({
  name: "Places",
  components: {
    Field,
    Button,
  },
  props: {
    room: {
      type: String,
      required: true,
    },
  },
  setup(prp) {
    document.title =
      decodeURIComponent(prp.room).slice(0, 1).toUpperCase() +
      decodeURIComponent(prp.room).slice(1) +
      " | Book searcher";

    const selectedRoom = ref(
      getKeyByValue(decodeURIComponent(prp.room), polishTranslate),
    );
    return { places, selectedRoom, polishTranslate };
  },
});
